import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Card } from '@/components/ui/Card';
import { Spinner } from '@/components/ui/Spinner';
import { Badge } from '@/components/ui/Badge';
import { Button } from '@/components/ui/Button';
import { useActiveLease } from '@/hooks/useLeases';
import { useReadings } from '@/hooks/useUtilities';
import { formatDate } from '@/utils/format';

export function UtilitiesPage() {
  const { t } = useTranslation();
  const { activeLease } = useActiveLease();
  const readings = useReadings(activeLease?.id ?? null);

  if (!activeLease) {
    return (
      <Card title={t('web.empty.no_active_lease')}>
        <p className="text-sm text-slate-600">{t('contacts.no_active_lease')}</p>
      </Card>
    );
  }

  if (activeLease.utility_mode === 'included') {
    return (
      <Card title={t('utilities.included_title')}>
        <p className="text-sm text-slate-600">{t('utilities.included_body')}</p>
      </Card>
    );
  }

  if (readings.isLoading) return <Spinner />;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold">{t('utilities.readings')}</h2>
        <Link to="/utilities/submit">
          <Button>{t('utilities.submit_reading')}</Button>
        </Link>
      </div>
      <Card>
        {readings.data && readings.data.length > 0 ? (
          <ul className="divide-y divide-slate-100">
            {readings.data.map((r) => (
              <li key={r.id} className="flex items-center justify-between py-3 text-sm">
                <div>
                  <p className="font-medium">{t(`utilities.types.${r.type}`)}</p>
                  <p className="text-xs text-slate-500">
                    {r.period_month}/{r.period_year} —{' '}
                    {r.submitted_at ? formatDate(r.submitted_at) : ''}
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <span className="font-mono">{r.value}</span>
                  <Badge tone={r.status === 'approved' ? 'success' : 'info'}>
                    {t(`utilities.status.${r.status}`)}
                  </Badge>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="py-6 text-center text-sm text-slate-500">{t('web.empty.no_data')}</p>
        )}
      </Card>
    </div>
  );
}
